<template>
  <div>
    <h3 class="text-base font-bold">All Transactions</h3>
    <p class="text-fg-muted text-xs font-normal">
      This shows only your USD transactions.
    </p>
    <div
      v-for="(transaction, index) in cardTransactions"
      :key="index"
      class="mt-2.5 pt-3.5 pb-4 border-b"
    >
      <div class="flex">
        <div class="flex">
          <div class="mr-5">
            <arrow-down :transactionType="transaction.type" />
          </div>
          <div>
            <h3 class="text-base font-bold">Deposit ****2343</h3>
            <p class="text-fg-muted text-xs font-normal">
              {{ transaction.date }}
            </p>
          </div>
        </div>
        <div class="ml-auto flex itemx-center">
          <div>
            <h3 class="text-base font-bold">$ {{ transaction.amount }}</h3>
            <div
              class="text-xs flex justify-center font-medium rounded-full py-1 px-2 capitalize"
              :class="statusClass(transaction.status)"
            >
              {{ transaction.status }}
            </div>
          </div>
          <div class="flex items-center ml-3">
            <ArrowRightIcon />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { StatusClass } from '@/utils/helpers.js'
export default {
  components: {
    ArrowRightIcon: () => import('@/assets/icons/ArrowRightIcon.vue'),
    ArrowDown: () => import('@/assets/v2/icons/ArrowDown.vue')
  },
  data () {
    return {
      cardTransactions: [
        {
          date: '24 Aug, 6:10 AM',
          type: 'deposit',
          amount: '4,666',
          status: 'successful'
        },
        {
          date: '24 Aug, 1:20 PM',
          type: 'deposit',
          amount: '9,000',
          status: 'successful'
        },
        {
          date: '24 Aug, 6:10 AM',
          type: 'deposit',
          amount: '345',
          status: 'successful'
        },
        {
          date: '24 Aug, 6:10 AM',
          type: 'deposit',
          amount: '2,839',
          status: 'successful'
        },
        {
          date: '24 Aug, 6:10 AM',
          type: 'deposit',
          amount: '1,000',
          status: 'successful'
        },
        {
          date: '24 Aug, 6:10 AM',
          type: 'deposit',
          amount: '2,839',
          status: 'successful'
        },
        {
          date: '24 Aug, 6:10 AM',
          type: 'deposit',
          amount: '1,000',
          status: 'successful'
        }
      ]
    }
  },
  methods: {
    statusClass (val) {
      return StatusClass(val)
    }
  }
}
</script>

<style lang="scss" scoped></style>
